import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { RULES_LOGO, RULES_TEXT, RULES_VIDEO } from '../../data/brainTeasers';
import './RulesPage.css';

function Typewriter({ text, speed = 30, onDone }) {
  const [shown, setShown] = useState('');
  const doneRef = useRef(onDone);
  doneRef.current = onDone;

  useEffect(() => {
    setShown('');
    let i = 0;
    const id = setInterval(() => {
      i += 1;
      setShown(text.slice(0, i));
      if (i >= text.length) {
        clearInterval(id);
        doneRef.current?.();
      }
    }, speed);
    return () => clearInterval(id);
  }, [text, speed]);

  return <div className="bt-rules-line">{shown}</div>;
}

export default function RulesPage() {
  const navigate = useNavigate();
  const [showTitle, setShowTitle] = useState(false);
  const [showLine1, setShowLine1] = useState(false);
  const [showLine2, setShowLine2] = useState(false);
  const [showNext, setShowNext] = useState(false);

  useEffect(() => {
    document.body.classList.add('bt-round-active');
    return () => document.body.classList.remove('bt-round-active');
  }, []);

  useEffect(() => {
    const t = setTimeout(() => setShowTitle(true), 500);
    const t2 = setTimeout(() => setShowLine1(true), 1000);
    return () => {
      clearTimeout(t);
      clearTimeout(t2);
    };
  }, []);

  return (
    <div className="bt-rules-page">
      <video className="bt-fullscreen-video" src={RULES_VIDEO} playsInline autoPlay muted loop />
      <div className="bt-rules-content">
        <img src={RULES_LOGO} alt="Brain Teasers" className="bt-rules-logo" />
        {showTitle ? <h3 className="bt-rules-heading">Rules</h3> : null}
        {showLine1 ? (
          <Typewriter
            text={RULES_TEXT[0]}
            onDone={() => {
              setTimeout(() => setShowLine2(true), 1000);
            }}
          />
        ) : null}
        {showLine2 ? (
          <Typewriter
            text={RULES_TEXT[1]}
            onDone={() => {
              setTimeout(() => setShowNext(true), 1000);
            }}
          />
        ) : null}
        {showNext ? (
          <button type="button" className="bt-rules-next" onClick={() => navigate('/rounds/1')}>
            Next
          </button>
        ) : null}
      </div>
    </div>
  );
}
